<template>
  <div class="ipo-table-wrap">
    <table class="ipo-table">
      <caption class="sr-only">{{ phase === 'upcoming' ? 'Próximas salidas a bolsa' : 'Salidas a bolsa recientes' }}</caption>
      <thead>
        <tr>
          <th :aria-sort="ariaSort('ticker')">
            <button type="button" @click="$emit('sort', 'ticker')">Ticker <span aria-hidden="true">{{ indicator('ticker') }}</span></button>
          </th>
          <th :aria-sort="ariaSort('company')">
            <button type="button" @click="$emit('sort', 'company')">Empresa <span aria-hidden="true">{{ indicator('company') }}</span></button>
          </th>
          <th>País</th>
          <th :aria-sort="ariaSort('date')">
            <button type="button" @click="$emit('sort', 'date')">
              {{ phase === 'upcoming' ? 'Fecha prevista' : 'Fecha de salida' }}
              <span aria-hidden="true">{{ indicator('date') }}</span>
            </button>
          </th>
          <th><span class="sr-only">Acciones</span></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td class="ipo-table__ticker">{{ item.ticker }}</td>
          <td>{{ item.companyName || 'Sin nombre disponible' }}</td>
          <td>{{ item.country.label }}</td>
          <td>
            <span v-if="phase === 'upcoming'" class="ipo-date-badge">Prevista</span>
            {{ formatDate(item.listingDate) }}
          </td>
          <td class="ipo-table__action">
            <a
              v-if="item.isTrading"
              :href="chartingHref(item.ticker)"
              target="_blank"
              rel="noopener"
              :aria-label="`Abrir ${item.ticker} en el graficador, en una pestaña nueva`"
            >Abrir en graficador <span aria-hidden="true">↗</span></a>
            <span v-else>Aún no disponible</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { buildChartingAppHref } from '@/features/charting-next/utils/chartingLinks';
import { formatIpoDate } from '@/features/upcoming-ipos/models/upcomingIpos';

export default {
  name: 'UpcomingIposTable',
  props: {
    items: { type: Array, required: true },
    phase: { type: String, required: true },
    sortField: { type: String, required: true },
    sortDirection: { type: String, required: true }
  },
  methods: {
    formatDate: formatIpoDate,
    chartingHref(ticker) { return buildChartingAppHref({ type: 'ticker', value: ticker }); },
    ariaSort(field) {
      if (this.sortField !== field) return 'none';
      return this.sortDirection === 'asc' ? 'ascending' : 'descending';
    },
    indicator(field) {
      if (this.sortField !== field) return '';
      return this.sortDirection === 'asc' ? '↑' : '↓';
    }
  }
};
</script>

<style lang="scss" scoped>
.ipo-table-wrap { overflow-x: auto; }
.ipo-table { width: 100%; min-width: 800px; border-collapse: collapse; font-size: 13px; text-align: left; }
.ipo-table th { padding: 12px 16px; background: color-mix(in srgb, var(--modern-bg) 75%, var(--modern-surface)); color: var(--modern-muted); font-size: 11px; letter-spacing: .045em; text-transform: uppercase; }
.ipo-table th button { padding: 0; border: 0; background: none; color: inherit; cursor: pointer; font: inherit; font-weight: 800; letter-spacing: inherit; text-transform: inherit; }
.ipo-table td { padding: 15px 16px; border-top: 1px solid var(--modern-border); }
.ipo-table tbody tr:hover { background: color-mix(in srgb, var(--modern-accent-soft) 45%, transparent); }
.ipo-table__ticker { color: var(--modern-text); font-weight: 800; }
.ipo-table__action { text-align: right; white-space: nowrap; }
.ipo-table__action a { color: var(--modern-accent); font-weight: 700; text-decoration: none; }
.ipo-table__action > span { color: var(--modern-muted); font-size: 12px; }
.ipo-date-badge { margin-right: 7px; padding: 3px 7px; border-radius: 999px; background: var(--modern-accent-soft); color: var(--modern-accent); font-size: 10px; font-weight: 800; text-transform: uppercase; }
.ipo-table button:focus-visible, .ipo-table a:focus-visible { outline: 3px solid var(--modern-accent-soft); outline-offset: 2px; }
.sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }
@supports not (color: color-mix(in srgb, white 50%, black)) {
  .ipo-table th { background: var(--modern-bg); }
}
</style>
